import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CtbCtaService,CtbCtaDto, CargaCuentasExcel } from '../ctb-cta.service';
import { LoginService } from '../../../login/login.service';
import { CtbConfService } from '../../ctb-conf/ctb-conf.service';
import Swal from 'sweetalert2';
import {PaginadorService, PageBusquedaObject} from '../../../paginador/paginador.service';
import * as XLSX from 'xlsx';
declare var $: any;
@Component({
  templateUrl: './catalogo-ctb-cta.component.html',
  styleUrls: ['./catalogo-ctb-cta.component.css'],
  providers: [CargaCuentasExcel],
  preserveWhitespaces: true
})
export class CatalogoCtbCtaComponent implements OnInit {
  catalogosPreinstalados: any[] = [];
  busqueda: PageBusquedaObject = new PageBusquedaObject();
  totalItems: number;
  rotate: any;
  estructura = '';
  maxLengthCuenta: number;
  arrayBuffer: any;
  items: CtbCtaDto[] = [];
  tipoCuenta: any[];
  cargado: boolean;
  errors: any[];
  nombre_catalogo: string;
  titulo_paginador = 'cta-paginador';
  tipo_mensaje = '';
  mensaje_error = '';
  
  cuenta_param: string | null = null;
  nombre_param: string | null = null;
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  constructor(private paginadorService:PaginadorService, private confService: CtbConfService, private router: Router, private ctaService: CtbCtaService,
    public loginService: LoginService, private cargaCuentasExcel: CargaCuentasExcel,private route: ActivatedRoute) {
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.cuenta_param = params['cuenta'] || null;
      this.nombre_param = params['nombre'] || null;

      console.log('Cuenta recibida:', this.cuenta_param);
      console.log('Nombre recibido:', this.nombre_param);

      // Aquí puedes inicializar tu formulario con estos valores
      // Ejemplo:
      // this.form.patchValue({ cuenta: this.cuenta, nombre: this.nombre });
    });
    this.busqueda = this.paginadorService.getBusquedaCatalogo(this.titulo_paginador);
    this.busqueda.page1 = true;
    this.busqueda.criteriaSearch['cod_agrupador'] = '0';
    this.busqueda.criteriaSearch['estatus'] = true;
    this.estructura = this.loginService.usuario.empresa_seleccionada.estructura1;
    this.maxLengthCuenta = this.estructura.length;
    this.cargarTiposCuenta();
    this.cargarCatalogo();
  }
  uploadDataXls(event: any): void {
    this.mostrarMensajeCarga('Cargando datos del excel');
    const file = event.target.files[0];
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      const data = new Uint8Array(this.arrayBuffer);
      const arr = new Array();
      for (let i = 0; i !== data.length; ++i) {
        arr[i] = String.fromCharCode(data[i]);
      };
      const bstr = arr.join('');
      const workbook = XLSX.read(bstr, { type: 'binary' });
      const first_sheet_name = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[first_sheet_name];
      const array = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      this.cargaCuentasExcel.realizarCargaConArrayExcel(array, this.estructura,
        this.loginService.empresa, this.loginService.sucursal, this.loginService.usuario.id);
    }
    fileReader.readAsArrayBuffer(file);
    this.cerrarMensajeCarga();
  }
  cargarCatalogosPreinstalados() {
    this.confService.getCatalogoPreinstalado().subscribe(response => {
      this.catalogosPreinstalados = response.contenido;
      console.log(response)
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      this.errors = err.error.error;
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }
  asignarCatalogo(titulo: string) {
    this.nombre_catalogo = titulo;
  }
  instalarCatalogo() {
    this.ctaService.instalarCatalogo(this.loginService.empresa, this.loginService.usuario.id, this.nombre_catalogo)
      .subscribe(response => {
        Swal.fire(response.mensaje);
        this.cargarCatalogo();
      }, err => {
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        this.errors = err.error.error;
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        })
      });
  }
  cargarTiposCuenta() {
    this.ctaService.getTipo().subscribe(response => {
      this.tipoCuenta = response.contenido;
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  cargarCatalogo() {
    this.busqueda.criteriaSearch['suc'] = this.loginService.sucursal;
    this.busqueda.criteriaSearch['emp'] = this.loginService.empresa;
    if (this.cuenta_param != null && this.nombre_param != null) {
      this.busqueda.criteriaSearch['cuenta'] = this.cuenta_param;
      this.busqueda.criteriaSearch['nombre'] = this.nombre_param;
    } 
    this.ctaService.ctaCatalogo(this.busqueda).subscribe(response => {
      this.items = response.contenido.content;
      this.totalItems = response.contenido.totalElements;
    if (this.cuenta_param != null && this.nombre_param != null) {
      if (this.items.length === 1) {
        this.router.navigate(['/contabilidad/catalogo/ctb-cta/actualizar', this.items[0].id], { queryParams: { sinMenu: true } });
      }}
      if (response.tipo_mensaje === 'Alert') {
        this.tipo_mensaje = response.tipo_mensaje;
        //this.showNotification(response.mensaje);
        this.mensaje_error = response.mensaje;
      }
      this.paginadorService.setBusquedaCatalogo(this.titulo_paginador,this.busqueda);
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  cambiarPagina(event: any): void {
    this.busqueda.pageNumber = event.page;
    this.cargarCatalogo();
  }
  filtroDeBusqueda(find: any, columnName: any): void {
    this.busqueda.criteriaSearch[columnName] = find;
  }
  sortearPor(columnName: any): void {
    this.busqueda.column = columnName;
    this.busqueda.sort = true;
    this.busqueda.pageNumber = 1;
    switch (this.busqueda.order) {
      case 'desc':
        this.busqueda.order = 'asc';
        break;
      default:
        this.busqueda.order = 'desc';
        break;
    }
    this.cargarCatalogo();
  }
  buscarEnCatalogo(): void {
    this.busqueda.pageNumber = 1;
    this.cargarCatalogo();
  }
  limpiarBusqueda(): void {
    this.busqueda.criteriaSearch = {};
    this.busqueda.criteriaSearch['cod_agrupador'] = '0';
    this.busqueda.criteriaSearch['estatus'] = true;
    this.buscarEnCatalogo();
  }
  exportAsXLSX(): void {
  }
  eliminar(dtoEliminar: CtbCtaDto): void {
    Swal.fire({
      title: 'Atención',
      text: `¿Está seguro de inactivar la Cuenta Contable?`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.value) {
        this.ctaService.deleteTpol(dtoEliminar.id, this.loginService.usuario.id).subscribe(response => {
          Swal.fire('TNK Ledger', response.mensaje, 'success');
          this.buscarEnCatalogo();
        }, err => {
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire('TNK Ledger', err.error.mensaje, 'error');
        });
      }
    });
  }
  showNotification(mensaje: any) {
    const color = 'danger';
    $.notify({
      icon: 'pe-7s-info',
      message: mensaje
    }, {
        type: color,
        timer: 1000,
        placement: {
          from: 'top',
          align: 'center'
        }
      });
  }
  mostrarMensajeCarga(mensaje: string) {
    this.cargado = false;
    Swal.fire({
      title: 'TNK Ledger',
      html: mensaje = ! null ? mensaje : 'Procesando...',
      timerProgressBar: true,
      showConfirmButton: false,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      }
    });
  }
  mostrarMensajeError(mensaje: string){
    Swal.fire('TNK Ledger', mensaje, 'error');
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }
}
